import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { contentful } from '../../config';

import Heading from '../common/Heading';
import Loader from '../common/Loader';
import FalconCardHeader from '../common/FalconCardHeader';
import { ListGroup, ListGroupItem, Card, CardBody } from 'reactstrap';

function VendorIntegrationList() {
  const [page, setPage] = useState(null);
  const { category } = useParams();

  const query = `
{
  kbAppArticleCollection(where: {
    kbAppCategory: {
      slug: "${category}" }
    }) {
    items {
      kbAppCategory {
          name,
          slug
      }
      sys {
          id
      }
      title,
      slug,
      sectionsCollection {
          items {
           title,
           sys {
               id
           }
          }
      }
    }
  }
}
`;

  useEffect(() => {
    window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/${contentful.space}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + contentful.token
        },
        body: JSON.stringify({ query })
      })
      .then(response => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }

        setPage(data.kbAppArticleCollection.items);
      });
  }, [query]);

  if (!page) {
    return <Loader />;
  }

  // Sort alphabetically by title
  const sortedPage = page.sort(function(a, b) {
    return a.title.localeCompare(b.title);
  });

  // render the fetched Contentful data
  return (
    <>
      <Heading
        title={`${category === 'sso-sn-integration-guides' ? 'Integration Guides' : category.replace(/-/g, ' ')}`}
        subtitle="Browse our Documentation"
        className="mb-4 mt-3 text-capitalize"
        icon="book"
      />
      <Card>
        {/* <img src={page.logo.url} className="App-logo" alt="logo" /> */}
        <FalconCardHeader
          title={`${
            category === 'sso-sn-integration-guides'
              ? 'Integration Guides'
              : category === 'user-guides'
              ? 'User Guides'
              : category === 'vendor-configuration-guides'
              ? 'Documentation List'
              : category.replace(/-/g, ' ')
          }`}
        />
        <CardBody>
          <ListGroup data-testid={'vendor-list'}>
            {sortedPage.map(item => {
              return (
                <Link key={item.sys.id} to={`/documentation/${category}/${item.slug}`}>
                  <ListGroupItem>{item.title}</ListGroupItem>
                </Link>
              );
            })}
          </ListGroup>
        </CardBody>
      </Card>
    </>
  );
}

export default VendorIntegrationList;
